export default {"src":"/_next/static/media/bike.055c740d.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};